import { Link } from "react-router-dom";
import { Breadcrumb } from 'react-bootstrap';
import { useEffect } from "react";
import '../App.css';
import HelpButton from "./HelpButton";

/*사무실*/
function Office() {
  
  useEffect(() =>{
    const startTime = new Date().getTime();
    localStorage.setItem('startTime', startTime.toString());
  }, [])

  useEffect(() => {
  const handleBeforeUnload = () => {
    localStorage.setItem('helpButtonClicked', 'false'); // 새로고침 시 전역 상태 리셋
  };

  window.addEventListener('beforeunload', handleBeforeUnload);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, []);

  return (
    <div className="container mt-4 position-relative" style={{ height: '100vh' }}>
      {/* Breadcrumb */}
      <div className="d-flex justify-content-between align-items-center">
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={(e) => {
            e.preventDefault();  // 링크 기본동작 막기
            alert('아직 일을 마치지 못했다');
          }}
          href="#" // href 있어야 커서 포인터 모양 유지됨
          style={{ cursor: 'pointer' }} // 클릭 가능하다는 시각적 표시
        >
          집
        </Breadcrumb.Item>
        <Breadcrumb.Item active>사무실</Breadcrumb.Item>
      </Breadcrumb>
      {/* 오른쪽 상단 버튼 */}
          <HelpButton />

        </div>

      {/* 수평선 */}
      <hr className="border border-dark-subtle border-2 opacity-100" />

      {/* 설명 */}
      <div className="text-start">
        <p>국내 S급 각성자의 길드 소속이 된 지 벌써 1년. 최근 길드장님과 연락이 닿지 않는다</p>
        <p>길드장님께 직접 전달해 드려야 할 물건이 있는데... </p>
        <p>길드장님을 찾아가 봐야겠다</p>
      </div>

      {/* 화면 정중앙 링크 */}
      <div
        className="d-grid gap-2 col-10 col-sm-8 col-md-6 col-lg-4 mx-auto"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          gap: '1rem',       // 버튼 사이 간격 (1rem = 16px 기본)
        }}
      >
        <Link to="/ceo-office" className="btn btn-secondary">
          대표실에 들어가기
        </Link>
        <Link to="/house" className="btn btn-secondary">
          자택으로 찾아가기
        </Link>
      </div>

    </div>

  );
}

export default Office;